import { render, staticRenderFns } from "./AddNewProduct.vue?vue&type=template&id=c7bfbe3c&scoped=true&"
import script from "./AddNewProduct.vue?vue&type=script&lang=js&"
export * from "./AddNewProduct.vue?vue&type=script&lang=js&"
import style0 from "./AddNewProduct.vue?vue&type=style&index=0&id=c7bfbe3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7bfbe3c",
  null
  
)

export default component.exports